import { render, staticRenderFns } from "./copyProductPersonal.vue?vue&type=template&id=b9dde682&scoped=true&"
import script from "./copyProductPersonal.vue?vue&type=script&lang=js&"
export * from "./copyProductPersonal.vue?vue&type=script&lang=js&"
import style0 from "./copyProductPersonal.vue?vue&type=style&index=0&id=b9dde682&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9dde682",
  null
  
)

export default component.exports